import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'

export const useDeleteExternalRecipientMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<void, ApiResponseError, number>({
    mutationFn: (id) =>
      fetchApiWithToken<void>({
        method: 'delete',
        url: `/v1/external_recipients/${id}`
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['addressbook'] })
    }
  })
}
